'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.attributeValue = exports.attribute = exports.attributes = exports.allAttributes = undefined;

var _ramda = require('ramda');

var _shared = require('./shared');

var _nodeNames = require('./nodeNames');

var allAttributes = (0, _ramda.compose)(_shared.coalesceArray, (0, _ramda.prop)('attributes'));

var attributes = function attributes(localName, uri) {
    return (0, _ramda.compose)((0, _ramda.filter)((0, _nodeNames.hasName)(localName, uri)), allAttributes);
};

var attribute = function attribute(localName, uri) {
    return (0, _ramda.compose)(_shared.normalizeToNull, _ramda.head, attributes(localName, uri));
};

var attributeValue = function attributeValue(localName, uri) {
    return function (node) {
        var isNilUri = (0, _ramda.isNil)(uri);
        var present = isNilUri ? node.hasAttribute(localName) : node.hasAttributeNS(uri, localName);

        if (!present) {
            return null;
        }

        return isNilUri ? node.getAttribute(localName) : node.getAttributeNS(uri, localName);
    };
};

exports.allAttributes = allAttributes;
exports.attributes = attributes;
exports.attribute = attribute;
exports.attributeValue = attributeValue;